"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementFingerprintAsync = void 0;
const elementDescriptor_1 = require("./elementDescriptor");
const hash = async (input) => {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));
    return Array.from(new Uint8Array(digest))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
};
/** The browser counterpart of `createElementFingerprint`. */
const createElementFingerprintAsync = async (input) => `${elementDescriptor_1.ELEMENT_FINGERPRINT_VERSION}:${await hash((0, elementDescriptor_1.buildElementDescriptor)(input))}`;
exports.createElementFingerprintAsync = createElementFingerprintAsync;
//# sourceMappingURL=createElementFingerprintAsync.js.map